{
  "open": "Rechercher…",
  "shortcut": "Ctrl+K",
  "title": "Recherche",
  "placeholder": "Rechercher une page, un tableau de bord, une source…",
  "inputLabel": "Rechercher dans VISION360",
  "resultsLabel": "Résultats",
  "searching": "Recherche en cours…",
  "remoteError": "La recherche complète a échoué : seuls les résultats locaux sont affichés.",
  "empty": "Aucun résultat pour « {{query}} ».",
  "count_one": "{{count}} résultat",
  "count_other": "{{count}} résultats",
  "groups": {
    "recent": "Récents",
    "page": "Pages",
    "dashboard": "Tableaux de bord",
    "source": "Sources",
    "alert": "Alertes",
    "rule": "Règles",
    "event": "Événements"
  },
  "pages": {
    "home": "Accueil",
    "sources": "Sources",
    "alerts": "Alertes",
    "rules": "Règles",
    "settings": "Paramètres"
  },
  "hints": {
    "move": "naviguer",
    "open": "ouvrir",
    "close": "fermer",
    "enter": "Entrée",
    "escape": "Échap"
  }
}
